module.exports = __webpack_public_path__ + "static/media/ev-6.6b2496c2.jpg";